import { Result } from './../types/Result';
import NetworkUtil from "./NetworkUtil";
import {SubmittingProvider} from './../types/SubmittingProvider';

export default class ProviderAPI {

  public static async getAllSubmittingProviders(): Promise<{ success: boolean, reason: string, data: SubmittingProvider[] }> {
    return NetworkUtil.makeGet("/api/admin/providers");
  }

  public static async createProvider(provider): Promise<{ success: boolean, reason: string, contactID:string, fullName?: string, alreadySetUp?: boolean, linkedExisting?: boolean}> {
    return NetworkUtil.makePost("/api/admin/providers/create", { provider: provider });
  }

  public static async lookupNPI(npiNumber: string): Promise<{ success: boolean, reason: string, data: { found: boolean, contactID: string | null, fullName: string, address: string, city: string, state: string, zip: string } | null }> {
    return NetworkUtil.makePost("/api/admin/providers/lookup-npi", { NPI_Number: npiNumber });
  }

  public static async filterProviders(filter: { filter: { FullName?, ContactID?, NPI_Number?, FacilityID?} }): Promise<{ success: boolean, reason: string, data: any[] }> {
    return NetworkUtil.makePost("/api/admin/providers/filter", filter);
  }

}